(function($) {
  'use strict';

  $(function() {
    if (window.RetroMaterialColorSwatches && window.RetroMaterialColorSwatches.initialized) {
      window.RetroMaterialColorSwatches.sync();
      return;
    }

    var groupSelector = '[data-material-color-selector]';
    var materials = null;

    function normalizeMaterial(value) {
      return String(value || '').toLowerCase().trim()
        .split(' ').join('-').split('(').join('').split(')').join('');
    }

    function getForm($group) {
      return $(document.getElementById($group.attr('data-form-id')));
    }

    function getGroups($form) {
      return $(groupSelector).filter(function() {
        return getForm($(this))[0] === $form[0];
      });
    }

    function initializeGroup($group) {
      var state = $group.data('materialColorState');
      if (state) return state;

      var $form = getForm($group);
      if (!$form.length) return null;

      var optionName = $group.attr('data-option-name').trim();
      var label = optionName.toLowerCase() === 'material' ? 'Color' : optionName + ' Color';
      var optionIndex = $group.attr('data-option-index');
      var $property = $form.find('[data-material-color-property]').filter(function() {
        return $(this).attr('data-material-color-property') === optionIndex;
      }).first();

      if (!$property.length) {
        $property = $('<input>', { type: 'hidden' }).appendTo($form);
      }
      $property.attr({
        name: 'properties[' + optionName + ']',
        'data-material-color-property': optionIndex
      }).val('').prop('disabled', true);
      $group.find('[data-material-color-label]').text(label);
      $group.find('.color-required-error').text('Please select ' + label.toLowerCase() + '.');

      state = { label: label, material: null, colors: [], selected: '', $property: $property };
      $group.data('materialColorState', state);
      return state;
    }

    function selectedMaterial($group) {
      var $controls = $group.prevAll('.variant-wrapper').first().find('[data-variant-input]');
      return String($controls.filter('select, :checked').first().val() || '').trim();
    }

    function updateProperty($group, state) {
      var color = String(state.selected || '').trim().replace(/(^|[\s/-])\S/g, function(initial) {
        return initial.toUpperCase();
      });
      var value = color ? selectedMaterial($group) + ' \u2014 ' + color : '';
      state.$property.val(value).prop('disabled', !state.selected);
    }

    function applyColor($group, color) {
      var state = initializeGroup($group);
      if (!state) return;
      state.selected = color;
      updateProperty($group, state);
      $group.find('[data-material-color-input]').each(function() {
        var selected = this.value === color;
        $(this).prop('checked', selected).closest('.material-swatch-color')
          .find('.color-swatch-img').toggleClass('selected-color', selected);
      });
      $group.find('.color-required-error').hide();
    }

    function renderColors($group, state, material) {
      state.material = material;
      state.colors = materials[material] || [];
      state.selected = '';
      state.$property.val('').prop('disabled', true);
      var $values = $group.find('[data-material-color-values]').empty();
      $group.find('.color-required-error').hide();
      $group.toggle(state.colors.length > 0);
      if (!state.colors.length) return;

      var $colors = $('<div>', { class: 'material-colors', 'data-material': material });
      state.colors.forEach(function(color, index) {
        var id = $group.attr('id') + '-color-' + index;
        var $swatch = $('<div>', { class: 'material-swatch-color' });
        $('<input>', {
          type: 'radio', id: id, name: $group.attr('id') + '-selection', value: color.name,
          'data-material-color-input': ''
        }).appendTo($swatch);
        var $label = $('<label>', { for: id }).appendTo($swatch);
        var $image = $('<div>', { class: 'color-swatch-img', 'data-value': color.name }).appendTo($label);
        $('<img>', { class: 'swatch-image', src: color.image, width: 50, height: 50, alt: color.name }).appendTo($image);
        var $hover = $('<div>', { class: 'hidden-swatch', 'aria-hidden': 'true' }).appendTo($label);
        $('<img>', { src: color.image, alt: '' }).attr({ width: 200, height: 200 }).appendTo($hover);
        $('<div>').text(color.name).appendTo($hover);
        $colors.append($swatch);
      });
      $values.append($colors);
      if (state.colors.length === 1) applyColor($group, state.colors[0].name);
    }

    function selectedVariantAllowsCart($form) {
      var $button = $form.find('[data-add-to-cart]').first();
      var $selectedOption = $form.find('[data-product-select] option:selected');
      return !($selectedOption.length && $selectedOption.prop('disabled')) && !$button.hasClass('disabled');
    }

    function validateForm($form, showError) {
      var valid = true;
      getGroups($form).each(function() {
        var $group = $(this);
        var state = initializeGroup($group);
        var missing = materials === null || (state && state.colors.length > 1 && !state.selected);
        if (missing) valid = false;
        if (showError) $group.find('.color-required-error').toggle(!!missing);
      });
      $form.find('[data-add-to-cart]').first()
        .attr('data-color-required', valid ? 'false' : 'true')
        .prop('disabled', !valid || !selectedVariantAllowsCart($form));
      return valid;
    }

    function syncMaterialColors() {
      var $forms = $();
      $(groupSelector).each(function() {
        var $group = $(this);
        var state = initializeGroup($group);
        if (!state) return;
        $forms = $forms.add(getForm($group));
        if (materials === null) return;
        var material = normalizeMaterial(selectedMaterial($group));
        if (state.material !== material) renderColors($group, state, material);
        updateProperty($group, state);
      });
      $forms.each(function() { validateForm($(this), false); });
    }

    function validateColorSelection($scope, showError) {
      syncMaterialColors();
      var valid = true;
      var $forms = $scope.is('form') ? $scope : $scope.find('.product-single__form');
      $forms.each(function() {
        if (!validateForm($(this), showError)) valid = false;
      });
      return valid;
    }

    window.RetroMaterialColorSwatches = {
      initialized: true, sync: syncMaterialColors, validate: validateColorSelection
    };

    $('body').on('change', '[data-variant-input]', syncMaterialColors);
    $('body').on('change', '[data-material-color-input]', function() {
      var $group = $(this).closest(groupSelector);
      applyColor($group, this.value);
      validateForm(getForm($group), false);
    });
    document.addEventListener('variant:change', function() {
      // The theme updates its master variant select after dispatching this event.
      Promise.resolve().then(syncMaterialColors);
    });
    document.addEventListener('shopify:section:load', syncMaterialColors);
    document.addEventListener('quickview:loaded', syncMaterialColors);
    document.addEventListener('submit', function(event) {
      if (event.target.matches('.product-single__form') &&
          getGroups($(event.target)).length && !validateColorSelection($(event.target), true)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    syncMaterialColors();
    $.ajax({
      type: 'POST',
      url: 'https://app.retromoderndesigns.com/api/get-colors-by-material',
      data: {},
      dataType: 'json',
      success: function(response) {
        materials = Object.create(null);
        response.forEach(function(material) {
          materials[normalizeMaterial(material.material)] = material.colors;
        });
        syncMaterialColors();
      },
      error: function() {
        materials = Object.create(null);
        syncMaterialColors();
      }
    });
  });
})(jQuery);
